// 連線中斷提示：伺服器牌局請求失敗時蓋在畫面上，請玩家重新整理
//
// 長輩看得懂的大字、一顆大按鈕；按下後重新載入，回首頁可續打同一局的開頭。
//
// === 使用圖片 ===
// 無 — 純程式繪製（DOM overlay，不經 Phaser）

const OVERLAY_ID = 'mahjong-connection-error';
const OVERLAY_Z_INDEX = '2000'; // 高於預覽提示框（1000）
const OVERLAY_BG = 'rgba(0, 0, 0, 0.72)';
const CARD_BG = '#fff8e7'; // 米色卡片
const CARD_MAX_WIDTH_PX = 520;
const CARD_PADDING_PX = 32;
const CARD_RADIUS_PX = 20;
const TITLE_FONT_PX = 34;
const BODY_FONT_PX = 24;
const BUTTON_FONT_PX = 30;
const BUTTON_BG = '#a0322a'; // 與主按鈕同色
const BUTTON_PADDING = '18px 48px';
const TEXT_COLOR = '#3a2a1a';

export const showConnectionError = (detail?: string): void => {
  if (typeof document === 'undefined' || document.getElementById(OVERLAY_ID)) return;
  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  Object.assign(overlay.style, {
    position: 'fixed',
    inset: '0',
    zIndex: OVERLAY_Z_INDEX,
    background: OVERLAY_BG,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  });
  const card = document.createElement('div');
  Object.assign(card.style, {
    background: CARD_BG,
    maxWidth: `${CARD_MAX_WIDTH_PX}px`,
    padding: `${CARD_PADDING_PX}px`,
    borderRadius: `${CARD_RADIUS_PX}px`,
    textAlign: 'center',
    color: TEXT_COLOR,
    fontFamily: 'system-ui, sans-serif',
  });
  const title = document.createElement('div');
  title.textContent = '連線中斷了';
  Object.assign(title.style, { fontSize: `${TITLE_FONT_PX}px`, fontWeight: 'bold' });
  const body = document.createElement('div');
  body.textContent = '請確認網路後，按下面的按鈕重新連線。';
  Object.assign(body.style, { fontSize: `${BODY_FONT_PX}px`, margin: '16px 0 24px' });
  const button = document.createElement('button');
  button.textContent = '重新連線';
  Object.assign(button.style, {
    fontSize: `${BUTTON_FONT_PX}px`,
    padding: BUTTON_PADDING,
    background: BUTTON_BG,
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    cursor: 'pointer',
  });
  button.addEventListener('click', () => location.reload());
  card.append(title, body, button);
  if (detail) card.title = detail; // 除錯用：滑鼠停留可看錯誤原因
  overlay.append(card);
  document.body.append(overlay);
};
